module.exports = __webpack_public_path__ + "img/dengbao2_358.fef790ac.jpg";